import { render, staticRenderFns } from "./TriggerPopup.vue?vue&type=template&id=07288dfc"
import script from "./TriggerPopup.vue?vue&type=script&lang=js"
export * from "./TriggerPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jenniferhoude/Herd/fertilizer-canada-2024-wp/wp-content/plugins/baytek-agronomist-directory/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07288dfc')) {
      api.createRecord('07288dfc', component.options)
    } else {
      api.reload('07288dfc', component.options)
    }
    module.hot.accept("./TriggerPopup.vue?vue&type=template&id=07288dfc", function () {
      api.rerender('07288dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/source/vue/components/global/TriggerPopup.vue"
export default component.exports